import { types } from 'mobx-state-tree'

export const Webhook = types.model('Webhooks').props({
  user_passed_quiz: types.maybeNull(types.string),
  user_failed_quiz: types.maybeNull(types.string),
  user_completed_assignment: types.maybeNull(types.string),
})
